import { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import Button from "./Button";
import { ButtonProps } from "./Button";

type Props = {
  buttons: ButtonProps[];
  initialActive?: number;
  onChange?: (i: number) => void;
};

type SwitchButtonProps = ButtonProps & {
  first: boolean;
  last: boolean;
};

const ButtonSwitch = (args: Props) => {
  const [active, setActive] = useState(args.initialActive || 0);

  useEffect(() => {
    args.onChange && args.onChange(active);
  }, [active]);

  return (
    <div>
      {args.buttons.map((button, i) => {
        const first = i === 0;
        const last = i === args.buttons.length - 1;
        const isActive = i === active;
        const onClick = (event: any) => {
          setActive(i);
          button.onClick && button.onClick(event);
        };
        const props = { ...button, last, first, ghost: !isActive, onClick };
        return <StyledButton {...props} />;
      })}
    </div>
  );
};

const defaultProps = {
  initialActive: 0,
};

ButtonSwitch.defaultProps = defaultProps;
const StyledButton = styled(Button)<SwitchButtonProps>`
  border-radius: 0;
  height: 40px;
  ${({ variant }) =>
    css`
      border: 1px solid var(--nf-${variant || "primary"});
      border-right-width: 0.5px;
      border-left-width: 0.5px;
    `}
  ${({ first }) =>
    first &&
    css`
      border-radius: 6px 0 0 6px;
      border-left-width: 1px;
    `}
  ${({ last }) =>
    last &&
    css`
      border-radius: 0 6px 6px 0;
      border-right-width: 1px;
    `}
`;
export default ButtonSwitch;
